import { Component, ChangeDetectorRef, Input, AfterViewChecked, EventEmitter, Output } from '@angular/core';
import { FormBuilder } from "@angular/forms";
import { ID } from '@common/interfaces/id';
import { compressImage, compressImageForTheme } from '@ep-om/utils/imageTools';
import { TranslateService } from '@ngx-translate/core';

export type AvatarImageToolsDTO = { src: any, outWidth: number, outHeight: number, quality?: number };
export type ThemeImageToolsDTO = Pick<AvatarImageToolsDTO, 'src' | 'quality'>;


@Component({
  selector: 'upload-avatar',
  templateUrl: './upload-avatar.component.html',
  styleUrls: ['./upload-avatar.components.scss'],
})

export class UploadAvatarComponent implements AfterViewChecked {

  constructor(
    public fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private translate: TranslateService
  ) {}

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  submitted: boolean;

  registrationForm = this.fb.group({
    file: [null]
  })

  @Input() entityId: ID;
  @Input() type: 'avatar' | 'theme' = 'avatar';
  @Output() newAvatarOrTheme = new EventEmitter<{ id: string } & ({ avatar: string} | { theme: string })>();
  @Input() quality: number = 0.5;
  @Input() uploadMsg: string = `${this.translate.instant('PROFILE.UPLOAD_AVATAR')}`;

  uploadFile(event) {
    let reader = new FileReader(); // HTML5 FileReader API
    let file = event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      reader.readAsDataURL(file);

      // When file uploads set it to file formcontrol
      reader.onload = async () => {
        if (this.type === 'avatar') {
          const obj: AvatarImageToolsDTO = { src: reader.result, outWidth: 128, outHeight: 128, quality: this.quality };
          const temp = await compressImage(obj);
          this.newAvatarOrTheme.emit({ id: this.entityId, avatar: temp })
        }
        if (this.type === 'theme') {
          const obj: ThemeImageToolsDTO = { src: reader.result, quality: this.quality };
          const temp = await compressImageForTheme(obj);
          this.newAvatarOrTheme.emit({ id: this.entityId, theme: temp })
        }
      }
    }
  }

  onSubmit() {
    this.submitted = true;
    if(!this.registrationForm.valid) return false;
  }
}
